(function () {

    /**
     * 本地存储 KEY
     * 用于在浏览器中缓存 Google Ads 的归因数据
     * 防止用户在站内跳转后参数丢失
     */
    var STORAGE_KEY = 'shopify_google_ads_tracking_v1';


    /**
     * 第一步：从 URL 中获取 Google Ads 归因参数
     *
     * 示例：
     * ?utm_source=google
     * &utm_medium=cpc
     * &utm_campaign=test
     * &gclid=xxx
     */
    function getQueryParams() {
        var params = new URLSearchParams(window.location.search);

        return {
            utm_source: params.get('utm_source') || '',
            utm_medium: params.get('utm_medium') || '',
            utm_campaign: params.get('utm_campaign') || '',
            utm_content: params.get('utm_content') || '',
            utm_term: params.get('utm_term') || '',

            /**
             * Google Ads 自动标记参数
             */
            gclid: params.get('gclid') || '',
            gbraid: params.get('gbraid') || '',
            wbraid: params.get('wbraid') || ''
        };
    }


    /**
     * 工具函数：清理空值
     * 只保留有值的字段，避免无效数据写入
     */
    function clean(obj) {
        var result = {};

        Object.keys(obj).forEach(function (key) {
            if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
                result[key] = obj[key];
            }
        });

        return result;
    }


    /**
     * 第二步：保存 Google Ads 来源数据到浏览器
     *
     * 满足以下任意条件时执行：
     * 1. utm_source 为 google、google_ads、googleads 或 adwords
     * 2. URL 中存在 gclid、gbraid 或 wbraid
     *
     * 其他平台来源不处理
     */
    function saveGoogleAdsTracking() {
        try {
            var query = clean(getQueryParams());
            var source = (query.utm_source || '').toLowerCase();

            var isGoogleAdsSource = [
                'google',
                'google_ads',
                'googleads',
                'adwords'
            ].indexOf(source) !== -1;

            var hasGoogleAdsClickId = Boolean(
                query.gclid ||
                query.gbraid ||
                query.wbraid
            );

            // 非 Google Ads 来源直接跳过
            if (!isGoogleAdsSource && !hasGoogleAdsClickId) {
                return;
            }

            /**
             * 构建要存储的数据
             * 使用 google_ads_ 前缀，避免与其他平台字段冲突
             */
            var data = {
                google_ads_utm_source: query.utm_source || 'google',
                google_ads_utm_medium: query.utm_medium || '',
                google_ads_utm_campaign: query.utm_campaign || '',
                google_ads_utm_content: query.utm_content || '',
                google_ads_utm_term: query.utm_term || '',

                /**
                 * Google Ads 自动标记参数
                 */
                google_ads_gclid: query.gclid || '',
                google_ads_gbraid: query.gbraid || '',
                google_ads_wbraid: query.wbraid || '',

                /**
                 * 记录落地页路径
                 * 用于后续分析用户进入页面
                 */
                google_ads_landing_page: window.location.pathname + window.location.search
            };

            data = clean(data);

            // 写入浏览器本地存储
            if (Object.keys(data).length > 0) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
            }

        } catch (err) {
            // console.error('Save Google Ads tracking failed:', err);
        }
    }


    /**
     * 第三步：将 Google Ads 数据写入 Shopify cart attributes
     *
     * Shopify 不会自动保存 UTM 和 Google Ads 点击参数
     * 必须通过 /cart/update.js 手动写入
     */
    async function syncGoogleAdsToCart() {
        try {

            // 从浏览器读取缓存数据
            var raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return;

            var data = JSON.parse(raw);

            // 非 Google Ads 数据直接跳过
            if (!data || !data.google_ads_utm_source) return;


            /**
             * 获取当前购物车信息
             * 读取已有 attributes，避免覆盖其他字段
             */
            var cartRes = await fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                credentials: 'same-origin'
            });

            if (!cartRes.ok) {
                throw new Error('Read cart failed: ' + cartRes.status);
            }

            var cart = await cartRes.json();

            var currentAttrs = cart.attributes || {};
            var nextAttrs = Object.assign({}, currentAttrs);
            var changed = false;


            /**
             * 仅更新 google_ads_ 前缀字段
             * 不影响 Bigo、Facebook、TikTok 等其他来源数据
             */
            Object.keys(data).forEach(function (key) {
                if (currentAttrs[key] !== data[key]) {
                    nextAttrs[key] = data[key];
                    changed = true;
                }
            });

            // 如果没有变化，则不发请求
            if (!changed) return;


            /**
             * 写入 Shopify cart attributes
             * 这是归因链路的关键步骤
             */
            var updateRes = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: nextAttrs
                })
            });

            if (!updateRes.ok) {
                throw new Error('Update cart failed: ' + updateRes.status);
            }

            var updatedCart = await updateRes.json();

            // console.log('Google Ads tracking synced:', updatedCart.attributes);

        } catch (err) {
            // console.error('Sync Google Ads tracking failed:', err);
        }
    }


    /**
     * 执行流程：
     * 1. 保存 Google Ads 参数，防止站内跳转后丢失
     * 2. 写入购物车 attributes
     */
    saveGoogleAdsTracking();


    /**
     * 页面加载完成后执行写入逻辑
     * 确保 DOM 已就绪
     */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncGoogleAdsToCart);
    } else {
        syncGoogleAdsToCart();
    }

})();
